import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../Services/api";
import globals from "../../../../Globals.json";

export const getCfopAsync = createAsyncThunk(
  "get/cfops",
  async (activedStoreId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.cfops + `?paginate=false&store_id=${activedStoreId}`,
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const createCfopAsync = createAsyncThunk(
  "create/cfops",
  async (data: any, thunkAPI) => {
    try {
      const res = await api.post(globals.api.cfops, data);
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const editeCfopAsync = createAsyncThunk(
  "put/cfops",
  async (data: any, thunkAPI) => {
    try {
      const res = await api.put(globals.api.cfops + `/${data?.id}`, data);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const deleteCfopAsync = createAsyncThunk(
  "del/cfops",
  async (id: string, thunkAPI) => {
    try {
      const res = await api.delete(globals.api.cfops + `/${id}`);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
